export default __webpack_public_path__ + "static/media/empty-requests-in-review-img.1779df8b.svg";